import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
} from "@mui/material";
import { useAppDispatch } from "../../../app/hooks";
import {
  getAllMedBatch,
  restockBatch,
} from "../../../features/batch/batchSlice";

interface IProps {
  selectedMedicineId: any;
  setOpenRestockBatchModal?: any;
  setOpenReminder?: any;
  openReminder?: any;
  selectedBatch?: any;
  getMedicine?: any;
}

const RestockBatchModal = ({
  selectedMedicineId,
  setOpenRestockBatchModal,
  setOpenReminder,
  openReminder,
  selectedBatch,
  getMedicine,
}: IProps) => {
  const dispatch = useAppDispatch();
  const pharmacyId = localStorage?.getItem("pharmacyId");
  const [restockBatchData, setRestockBatchData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState<any>({
    totalBox: "",
    unitPerBox: "",
    totalStock: "",
  });

  const [totalBox, setTotalBox] = useState("");
  const [unitPerBox, setUnitPerBox] = useState("");
  const [totalStock, setTotalStock] = useState("");

  const handleAddRestock = async () => {
    const newErrors: any = {};

    // if (!totalBox || isNaN(Number(totalBox)) || Number(totalBox) <= 0) {
    //   newErrors.totalBox = "Required*";
    // }

    if (!unitPerBox || isNaN(Number(unitPerBox)) || Number(unitPerBox) <= 0) {
      newErrors.unitPerBox = "Required*";
    }
    if (!totalStock || isNaN(Number(totalStock)) || Number(totalStock) <= 0) {
      newErrors.totalStock = "Required*";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    if (!selectedBatch) return;

    const dto = {
      batch_id: selectedBatch?.id,
      quantity: parseInt(totalStock),
      pharmacy_id: parseInt(pharmacyId || "0"),
      add_by_admin: true,
      total_box: parseInt(totalBox),
      unit_per_box: parseInt(unitPerBox),
      price_per_box: selectedBatch?.cost_price || 0,
    };

    try {
      const res = await dispatch(restockBatch(dto));
      if (res?.payload?.success) {
        // Optionally close modal or reset form
        getMedicine();
        setTotalBox("");
        setUnitPerBox("");
        setTotalStock("");
        setErrors({});
        setOpenRestockBatchModal?.(false);
      }
    } catch (error) {
      console.error("Error in restocking:", error);
    }
  };

  useEffect(() => {
    const boxes = parseInt(totalBox);
    const units = parseInt(unitPerBox);

    if (!isNaN(boxes) && !isNaN(units)) {
      setTotalStock((boxes * units).toString());
    } else {
      setTotalStock("");
    }
  }, [totalBox, unitPerBox]);

  const batch = selectedBatch;

  return (
    <Box p={3}>
      {/* Heading */}

      <Box
        sx={{
          mb: 2,
          fontSize: "16px",
          fontWeight: 500,
          display: "inline-block",
        }}
      >
        <Box>
          Batch: {batch?.pharmacy_medicine?.name || "-"}{" "}
          <span style={{ marginLeft: 3 }}>
            [Batch #{batch?.batch_no || "----"}]
          </span>
        </Box>
        <Box
          sx={{
            height: "3px",
            backgroundColor: "#0055A9",
            mt: "2px",
            borderRadius: "4px",
            width: "100%",
          }}
        />
      </Box>

      {/* Three-column layout */}
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Bar Code:
          </Typography>
          <Typography fontSize={12} fontWeight={500} color="text.secondary">
            {batch?.pharmacy_medicine?.barcode || "-"}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Cost Price
          </Typography>
          <Typography fontSize={12} fontWeight={500} color="text.secondary">
            Rs. {batch?.cost_price || "-"}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Sell Price
          </Typography>
          <Typography fontSize={12} fontWeight={500} color="text.secondary">
            Rs. {batch?.sell_price || "-"}
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Expiry Date
          </Typography>
          <Typography fontSize={12} fontWeight={500} color="text.secondary">
            {batch?.expiry_date
              ? new Date(batch.expiry_date).toLocaleDateString("en-GB")
              : "-"}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Stock Purc. Price
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={500}>
            Rs. {batch?.stock_purchase_cost || "-"}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Extra Discount
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={500}>
            Rs. {batch?.batch_discount || "-"}
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Supplier
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={500}>
            {batch?.supplier?.supplier_company_name || "-"}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Supplier Invoice
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={500}>
            {batch?.stock_inv_no || "-"}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Production Date
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={500}>
            {batch?.production_date
              ? new Date(batch.production_date).toLocaleDateString("en-GB")
              : "-"}
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Stock Purc. Date
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={500}>
            {batch?.batch_purchase_date
              ? new Date(batch.batch_purchase_date).toLocaleDateString("en-GB")
              : "-"}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Shelf
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={500}>
            {batch?.shelf?.name || "-"}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Remaining Qty
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={500}>
            {batch?.quantity - (batch?.quantity_sold || 0) || 0}
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Expiry Reminder
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={500}>
            {batch?.expiry_reminder || "-"} Months Before
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontSize={15} fontWeight={500}>
            Stock out Reminder
          </Typography>
          <Typography fontSize={12} color="text.secondary" fontWeight={500}>
            {batch?.pharmacy_medicine?.stock_out_reminders?.[0]
              ?.stock_out_reminder || "-"}
            %
          </Typography>
        </Grid>
      </Grid>

      {/* Restock Quantity Form */}
      <Box sx={{ mt: 4, mb: 2, fontSize: "16px", fontWeight: 500 }}>
        <Box>Restock Quantity</Box>
        <Box
          sx={{
            width: "130px",
            height: "3px",
            backgroundColor: "#0055A9",
            mt: "2px",
            borderRadius: "4px",
          }}
        />
      </Box>

      <Grid container spacing={2} alignItems="center">
        {/* Header Row */}
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontWeight: 500,
                  padding: "8px",
                  backgroundColor: "#F0F1F5",
                  textAlign: "center",
                }}
              >
                Total Boxes
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontWeight: 500,
                  padding: "8px",
                  backgroundColor: "#F0F1F5",
                  textAlign: "center",
                }}
              >
                Units Per Box
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontWeight: 500,
                  padding: "8px",
                  backgroundColor: "#F0F1F5",
                  textAlign: "center",
                }}
              >
                Total Stock
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Input Row */}
        <Grid item xs={4}>
          <Box sx={{ minHeight: 60 }}>
            {" "}
            {/* Adjust height as needed */}
            <TextField
              fullWidth
              placeholder="Add boxes"
              size="small"
              value={totalBox}
              onChange={(e) => setTotalBox(e.target.value)}
              // error={!!errors.totalBox}
              // helperText={errors.totalBox || " "}
              sx={{
                "& .MuiInputBase-root": {
                  height: 32,
                  fontSize: 12,
                },
                "& input": {
                  padding: "0 8px",
                },
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={4}>
          <Box sx={{ minHeight: 60 }}>
            <TextField
              fullWidth
              placeholder="Unit per box"
              size="small"
              value={unitPerBox}
              onChange={(e) => {
                setUnitPerBox(e.target.value);
                if (errors.unitPerBox) {
                  setErrors((prev: any) => ({ ...prev, unitPerBox: "" }));
                }
              }}
              error={!!errors.unitPerBox}
              helperText={errors.unitPerBox}
              sx={{
                "& .MuiInputBase-root": {
                  height: 32,
                  fontSize: 12,
                },
                "& input": {
                  padding: "0 8px",
                },
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ minHeight: 60 }}>
            <TextField
              fullWidth
              placeholder="Add total stock"
              size="small"
              value={totalStock}
              onChange={(e) => {
                setTotalStock(e.target.value);
                if (errors.totalStock) {
                  setErrors((prev: any) => ({ ...prev, totalStock: "" }));
                }
              }}
              //InputProps={{ readOnly: true }}
              error={!!errors.totalStock}
              helperText={errors.totalStock}
              sx={{
                "& .MuiInputBase-root": {
                  height: 32,
                  fontSize: 12,
                },
                "& input": {
                  padding: "0 8px",
                },
              }}
            />
          </Box>
        </Grid>

        {/* Add Button */}
        <Grid item xs={12} textAlign="right">
          <Button
            variant="contained"
            onClick={handleAddRestock}
            sx={{
              backgroundColor: "#0055A9",
              "&:hover": {
                backgroundColor: "#004080", // optional hover color
              },
            }}
          >
            ADD
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RestockBatchModal;
